module.exports = __webpack_public_path__ + "static/img/scratch.2ba26cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scratch.png
// module id = 999d0634d3b495e8
// module chunks = 59